export default class LayoutSql {
  constructor(IdLayoutSql, Descricao, Status, IdSql, Titulo, RecursoSistema, IdRecursoSistema, Configuracoes) {
    this.IdLayoutSql = IdLayoutSql || null;
    this.Descricao = Descricao;
    this.Status = Status || 'A';
    this.IdSql = IdSql || null;
    this.Titulo = Titulo;
    this.RecursoSistema = RecursoSistema;
    this.IdRecursoSistema = IdRecursoSistema || null;
    this.Configuracoes = Configuracoes || null;
  }
}